import React from 'react';
import { Avatar } from '../../flayr-components/Avatar/Avatar';
import { Flex } from '../../flayr-components/Flex/Flex';
import { Img } from '../../flayr-components/Img/Img';
import { Modal } from '../../flayr-components/Modal/Modal';
import { ReadMore } from '../../flayr-components/ReadMore/ReadMore';
import useClearableState from '../../hooks/useClearableState';
import ArrayMap from '../../lib/ArrayMap/ArrayMap';
import Portal from '../../lib/Portal/Portal';
import Scroller from '../../lib/Scroller/Scroller';
import ScrollerItem from '../../lib/ScrollerItem/ScrollerItem';
import { ITestimonial } from '../../types/testimonial';

interface ITestimonialItemProps {
  item?: ITestimonial;
  className?: string;
}

const TestimonialItem: React.FC<React.PropsWithChildren<React.PropsWithChildren<ITestimonialItemProps>>> = ({
  item,
  className,
}) => {
  const [previewImg, setPreviewImg, clearPreviewImg] = useClearableState('');

  function handleImgSelect(e) {
    setPreviewImg(e.src);
  }
  return (
    <div className={className}>
      <div className="flex flex-col h-full p-3 border rounded-lg shadow-lg">
        <Flex>
          <Avatar
            size="10"
            name={item?.customerName}
            className="mr-3"
            singleChar
            img={item?.customerPhoto}
          />
          <div className="">
            <div className="text-base font-medium leading-none">
              {item?.customerName}
            </div>

            <span className="text-sm text-gray-400">
              {item?.testimonialDate}
            </span>
          </div>
          <div className="ml-auto"></div>
        </Flex>
        <div className="my-3 text-sm">
          <ReadMore
            text={item?.testimonialText}
            lines={4}
            showHideTextClassName="text-sm underline"
          />
        </div>
        <Scroller innerContainerClassName="p-1">
          <ArrayMap
            items={item?.media || []}
            render={(img) => (
              <ScrollerItem>
                <Img
                  src={img}
                  size="square"
                  className="cursor-pointer"
                  roundedCorners
                  shadow
                  onClick={handleImgSelect}
                />
              </ScrollerItem>
            )}
          />
        </Scroller>
        <div className="mt-auto text-xs text-right">Source: {item?.source}</div>
      </div>
      <Portal>
        <Modal
          open={!!previewImg}
          size="sm"
          footer
          cancelBtnProps={{ hidden: true }}
          okLabel="Close"
          onClose={clearPreviewImg}
          onOk={clearPreviewImg}
          removeWhenClosed
        >
          <Img src={previewImg} />
        </Modal>
      </Portal>
    </div>
  );
};
export default TestimonialItem;
